'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	class: {
		type: 'string'
	},
	collapsed: {
		type: 'boolean'
	},
	items: {
		type: 'array'
	},
	multiple: {
		type: 'boolean'
	},
	onClick: {
		type: 'function'
	}
};

var initialState = function initialState() {
	return {
		active: []
	};
};

var handleSetActive = function handleSetActive(obj, _ref, onClick, setState) {
	var el = _ref.el,
	    i = _ref.i;

	setState(obj);

	if (onClick) {
		onClick(obj.active, _extends({}, el, { i: i, isOpen: obj.active.indexOf(i) !== -1 }));
	}
};

var setActive = function setActive(i, _ref2, _ref3, setState) {
	var el = _ref2.el,
	    multiple = _ref2.multiple,
	    onClick = _ref2.onClick;
	var active = _ref3.active;
	return function () {
		var index = active.indexOf(i);

		if (!multiple) {
			if (index !== -1) {
				handleSetActive({ active: [] }, { el: el, i: i }, onClick, setState);
				return;
			}

			handleSetActive({ active: [i] }, { el: el, i: i }, onClick, setState);
			return;
		}

		if (index !== -1) {
			active.splice(index, 1);
			handleSetActive({ active: active }, { el: el, i: i }, onClick, setState);
			return;
		}

		active.push(i);
		handleSetActive({ active: active }, { el: el, i: i }, onClick, setState);
	};
};

var getElements = function getElements(_ref4, _ref5, setState) {
	var items = _ref4.items,
	    multiple = _ref4.multiple,
	    onClick = _ref4.onClick,
	    styleClasses = _ref4.styleClasses;
	var active = _ref5.active;
	return items.map(function (x, i) {
		return (0, _magicVirtualElement2.default)(
			'div',
			{ key: i, 'class': ['Accordion-element', { 'Accordion-element--active': active.indexOf(i) !== -1 }, styleClasses && styleClasses.Element], 'data-style-attr': 'Element' },
			(0, _magicVirtualElement2.default)(
				'div',
				{ id: x.identifier ? x.identifier + '-heading' : '', 'class': ['Accordion-heading', styleClasses && styleClasses.Heading], 'data-style-attr': 'Heading', onClick: setActive(i, { x: x, multiple: multiple, onClick: onClick }, { active: active }, setState) },
				x.heading
			),
			(0, _magicVirtualElement2.default)(
				'div',
				{ id: x.identifier ? x.identifier : '', 'class': ['Accordion-content', styleClasses && styleClasses.Content], 'data-style-attr': 'Content' },
				x.content
			)
		);
	});
};

var setItems = function setItems(_ref6, setState) {
	var items = _ref6.items,
	    multiple = _ref6.multiple;

	var active = [];

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = items.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _step$value = _slicedToArray(_step.value, 2),
			    index = _step$value[0],
			    item = _step$value[1];

			if (!item.active) {
				continue;
			}

			if (!multiple) {
				active = [index];
				continue;
			}

			active.push(index);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	setState({ active: active });
};

var afterMount = function afterMount(_ref7, el, setState) {
	var props = _ref7.props;
	return setItems(props, setState);
};
var afterUpdate = function afterUpdate(_ref8, prevProps, prevState, setState) {
	var props = _ref8.props;
	return !(0, _deepEqual2.default)(props, prevProps) && setItems(props, setState);
};

var render = function render(_ref9, setState) {
	var props = _ref9.props,
	    state = _ref9.state;
	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Accordion', props.class, props.styleClasses && props.styleClasses.Accordion], 'data-style-attr': 'Accordion' },
		getElements(props, state, setState)
	);
};

exports.default = { afterMount: afterMount, afterUpdate: afterUpdate, initialState: initialState, propTypes: propTypes, render: render };
